import {ChangeDetectionStrategy, ChangeDetectorRef, Component, inject, OnInit, signal} from '@angular/core';
import {MatDialogRef} from '@angular/material/dialog';
import {ButtonModule} from '../button/button.module';
import {DialogModule} from '../dialog/dialog.module';
import {MatIconModule} from '@angular/material/icon';
import {getOS} from '../../../common/utils/helpers';
import {Platforms} from '../../../common/models/interfaces';
import {SUBSCRIPTIONS} from '../../../common/utils/constants';
import {getBasic} from '../../smart/embed-script/embed-script-code';
import * as Prism from 'prismjs';
import {UserInfoQuery} from '../../../common/elf-store/user-info/user-info.query';
import {AutoUnsubscribe} from '../../../decorators/auto-unsubscribe.decorator';
import {NgOptimizedImage} from '@angular/common';
import {HelperService} from '../../../services/helper.service';
import {UserApiService} from '../../../services/api/users-api.service';

@Component({
  selector: 'mc-welcome-modal',
  standalone: true,
  imports: [ButtonModule, DialogModule, MatIconModule, NgOptimizedImage],
  templateUrl: './welcome-modal.component.html',
  styleUrl: './welcome-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
@AutoUnsubscribe()
export class WelcomeModalComponent implements OnInit {
  codeScriptContent = signal('');
  codeScript: string = '';
  isWindowsOS: boolean = getOS() === Platforms.Windows;

  private userInfoQuery = inject(UserInfoQuery);
  private helperService = inject(HelperService);
  private userApiService = inject(UserApiService);
  private dialogRef = inject(MatDialogRef<WelcomeModalComponent>);

  ngOnInit(): void {
    this[SUBSCRIPTIONS].add(
      this.userInfoQuery.userInfo$.subscribe(info => {
        this.codeScript = getBasic(info.code || info.accountCode);

        this.codeScriptContent.set(Prism.highlight(this.codeScript, Prism.languages.markup, 'js'));
      }),
    );
  }

  close() {
    this.dialogRef.close();
    this.userApiService.noTrialWelcomeScreenShown();
  }

  copyScript() {
    this.helperService.copyToClipboard(this.codeScript);
  }
}
